import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
  color?: 'primary' | 'gray'
}

const VulnerabilityAlertsModuleBrand: FC<Props> = ({ color = 'primary', size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    `${color}.200`,
    `${color}.300`,
    `${color}.400`,
    `${color}.500`,
    `${color}.600`,
    `${color}.700`,
    `${color}.900`,
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Alertas">
          <g id="Background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M104,640S-40.42,482.29,26,275C84,94,193.93,77.7,221,80c47,4,87.59,64.17,124,228,22,99,138.11,113,252,55s128.16-42.5,138-27c33,52,23.67,132.56-52.67,225.78S473,768,359,762,137.41,675,104,640Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M495.57,87.82A39.76,39.76,0,0,1,505,140.1c-7.26,11.78-31.72,24.29-43.46,37.89-32.22,37.3-13.39,37-43,45.83-23.37,6.93-59.88-15.49-74.76-58s2-87.4,17-90.51c24.37-5,41.39,4.71,77.41,7.81C458.26,84.83,482.79,77.83,495.57,87.82Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M589.41,585.69A50.06,50.06,0,0,1,525.9,564.8C517.21,549.7,518,515.14,510,494c-22-58-33-37-25-75,6.32-30,53-57,109-48s95.53,54.58,90,73c-9,30-30,43-55,81C615.05,546.2,608.11,577.54,589.41,585.69Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M149,568S49,434,88,312c24.08-75.32,49-100,243-140,109.68-22.61,280-56,355.78,14.67,63.91,59.6,26.55,127.66,16.89,152S613.89,486.22,600,515,534.44,655.78,499.22,680.89,393,748,291,689,170,594,149,568Z"
              />
              <path
                fill={fillColor600}
                d="M84.87,632.12c19.79,9.58,52.68,21.69,58.85,45.14,6.72,25.54-11.5,45.8-38.74,42.29C53.77,713,70.42,626.59,84.87,632.12Z"
              />
              <path
                fill={fillColor600}
                d="M763.56,214.33c-2.73,5.33-10.72,4.23-11.69-1.69-4.18-25.51-19.88-46.12-34.63-67.24-16.64-23.82-31-37.28,7.28-37.18C783.77,108.38,777.6,186.88,763.56,214.33Z"
              />
              <path fill={fillColor600} d="M766.15,265a10,10,0,0,1-17.3-10.05c2.78-4.78,6.91-13.92,11.69-11.14S768.92,260.2,766.15,265Z" />
            </g>
          </g>
          <g id="Icon">
            <g>
              <path
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={fillBG}
                d="M317,607.48l3.58,10.38a68.91,68.91,0,0,0,87.6,42.73h0A68.9,68.9,0,0,0,450.94,573l-3.57-10.38"
              />
              <path
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={fillBG}
                d="M359.61,192.29l-9-26.1A55.15,55.15,0,0,0,280.52,132h0a55.16,55.16,0,0,0-34.19,70.07l9,26.11"
              />
              <path
                stroke={strokeColor900}
                strokeWidth={strokenWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
                fill={fillBG}
                d="M196.28,389.63h0a136.29,136.29,0,0,1,84.48-173.22l51.55-17.74a136.28,136.28,0,0,1,173.22,84.47h0l27.36,79.52a60.16,60.16,0,0,0,30.5,34.46l24.51,11.94a60.12,60.12,0,0,1,30.49,34.46h0a56.86,56.86,0,0,1-35.24,72.27l-304.8,105a56.85,56.85,0,0,1-72.26-35.24h0a60.22,60.22,0,0,1,2.79-46L220.82,515a60,60,0,0,0,2.8-45.95Z"
              />
            </g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M468,184.25A62.94,62.94,0,1,1,405,247.19,62.93,62.93,0,0,1,468,184.25"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(VulnerabilityAlertsModuleBrand)
